import type { IconProps } from '../types/IconProps.ts';
export const ShieldLock: IconProps = {
    name: 'ShieldLock',
    children: [
        `<path d="M4 5.26q.02-.21.23-.23c2.45-.02 4.83-.82 6.79-2.3l.8-.6c.1-.08.25-.08.35 0l.81.6a11.5 11.5 0 0 0 6.8 2.3q.2.02.22.23v6.71a10.3 10.3 0 0 1-8.02 10.02A10.3 10.3 0 0 1 4 11.97z" />`,
        `<rect width="6" height="5" x="9" y="11" rx=".5" />`,
        `<path d="M14 11v-1a2 2 0 1 0-4 0v1" />`,
    ]
};